import fetchUrl from 'utils/fetch';

export const getCustomersWithoutContact = interventionIds =>
  fetchUrl('/pco-manager/interventions/customers.json', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(interventionIds),
  }).then(res =>
    res.json().then(bod => {
      const result = {
        status: res.status,
        body: bod,
      };
      return result;
    })
  );



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/validation/api.js